import React from 'react';
import './LogoBar.css';

const logos = [
  { src: 'https://embracebeautyclinic.com/assets/logo/allergan.png', alt: 'Allergan' },
  { src: 'https://embracebeautyclinic.com/assets/logo/Galderma_Logo.png', alt: 'Galderma' },
  { src: 'https://embracebeautyclinic.com/assets/logo/merz.png', alt: 'Merz' },
  { src: 'https://embracebeautyclinic.com/assets/revanesse.png', alt: 'Revanesse' },
  { src: 'https://embracebeautyclinic.com/assets/logo/evolus-logo.png', alt: 'Evolus' },
  { src: 'https://embracebeautyclinic.com/assets/logo/freshclinics-logo.png', alt: 'Fresh Clinics' },
];

const LogoBar = () => {
  return (
    <section className="logobar">
      <div className="logobar-inner">
        <div className="logobar-track">
          {[...logos, ...logos].map((logo, i) => (
            <div className="logobar-item" key={i}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>

      {/* Consultation CTA */}

    </section>
  );
};

export default LogoBar;
